import type { PipelineStage } from '../types';
import { draftText } from '../draft-text';

const INSTRUCTION =
  "\n\nWhen proposing changes to an existing file, respond with a unified diff " +
  '(--- / +++ / @@ hunk headers, produced as if by `diff -u`) covering just the ' +
  'changed lines instead of rewriting the whole file. Use a normal fenced code block ' +
  'for new files or when a diff would be less clear than the full content.';

export const c2RequestDiffResponses: PipelineStage = {
  id: 'C2',
  group: 'C',
  label: 'Request diff-formatted responses',
  description: 'Ask Claude to respond with diffs/search-replace blocks for code changes instead of full rewrites.',
  impact: 'Medium',
  defaultEnabled: true,
  implemented: true,

  async run(draft, _params, ctx) {
    const tokensBefore = ctx.estimateTokens(draftText(draft));

    if (draft.openFiles.length === 0) {
      return {
        draft,
        report: {
          stageId: 'C2',
          tokensBefore,
          tokensAfter: tokensBefore,
          tokensSaved: 0,
          notes: ['No open files in this session — nothing to request diff-formatted edits against.'],
        },
      };
    }

    const newDraft = { ...draft, systemPrompt: draft.systemPrompt + INSTRUCTION };
    const tokensAfter = ctx.estimateTokens(draftText(newDraft));

    return {
      draft: newDraft,
      report: {
        stageId: 'C2',
        // This stage adds a small fixed instruction cost now to avoid Claude re-emitting whole
        // files in its reply later, so token savings show up in the response, not this request.
        tokensBefore,
        tokensAfter,
        tokensSaved: 0,
        notes: ['Instructed the model to prefer unified diffs over full file rewrites in its response.'],
      },
    };
  },
};
